export default __webpack_public_path__ + "static/media/animate2.ec3ba4fd.png";